import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Errore imprevisto" };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ENBISSY ErrorBoundary:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 24, textAlign: "center", background: "#fff", color: "#0a0a0a", fontFamily: "system-ui, sans-serif" }}>
          <div style={{ fontWeight: 800, letterSpacing: "0.18em", fontSize: 20, marginBottom: 12 }}>ENBISSY</div>
          <p style={{ color: "#666", maxWidth: 360, marginBottom: 20 }}>
            Si è verificato un problema nel caricamento della pagina. Riprova.
          </p>
          <button
            data-testid="error-reload-btn"
            onClick={() => { window.location.href = "/"; }}
            style={{ height: 48, padding: "0 28px", borderRadius: 999, background: "#0a0a0a", color: "#fff", border: "none", fontWeight: 600, fontSize: 16, cursor: "pointer" }}
          >
            Ricarica
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
